var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7, _rect2, _rect3, _g2, _path8, _path9, _path0, _path1, _ellipse2, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgOpenPassport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 120,
    viewBox: "0 0 186 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6970_149799",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 13,
    width: 67,
    height: 94
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.73375,
    y: 14.3216,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6970_149799)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.67188,
    y: 15.0566,
    width: 69.4819,
    height: 90,
    rx: 5.13,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5788,
    y: 65.6881,
    width: 28.3746,
    height: 10.6544,
    rx: 4.395,
    fill: "#7CE9DA",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8678,
    y: 93.6647,
    width: 17.1828,
    height: 3.19321,
    rx: 1.59661,
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4279 88.3114H30.8811C32.1469 88.3114 33.1767 87.2416 33.1767 85.9275V73.4015C33.1767 72.0873 32.1468 71.0176 30.8811 71.0176H16.4279C15.1627 71.0176 14.1328 72.0873 14.1328 73.4015V85.9275C14.1328 87.2416 15.1627 88.3114 16.4279 88.3114ZM27.8155 87.0659H19.4941V86.2164C19.4941 84.6856 20.27 83.3472 21.4289 82.5795C22.0838 82.9993 22.844 83.2446 23.6574 83.2446C24.4691 83.2446 25.2276 82.9998 25.8813 82.5808C27.0397 83.3486 27.8155 84.6862 27.8155 86.2165V87.0659ZM20.4461 78.4435C20.4461 76.4793 21.8869 74.8817 23.6574 74.8817C25.425 74.8817 26.8634 76.4793 26.8634 78.4435C26.8634 80.4041 25.425 81.9991 23.6574 81.9991C21.887 81.9991 20.4461 80.404 20.4461 78.4435ZM15.3319 73.4015C15.3319 72.7738 15.8237 72.263 16.4279 72.263H30.8811C31.4858 72.263 31.9777 72.7738 31.9777 73.4015V85.9275C31.9777 86.5551 31.4859 87.0659 30.8811 87.0659H29.0145V86.2164C29.0145 84.3873 28.1537 82.771 26.8383 81.7557C27.5948 80.8933 28.0625 79.7277 28.0625 78.4433C28.0625 75.7926 26.0866 73.6361 23.6574 73.6361C21.2253 73.6361 19.247 75.7925 19.247 78.4433C19.247 79.7261 19.7143 80.8901 20.4697 81.7522C19.1535 82.767 18.295 84.3867 18.295 86.2164V87.0659H16.4279C15.8237 87.0659 15.3319 86.5551 15.3319 85.9275V73.4015Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.26 82.2266H41.687C41.2467 82.2266 40.8906 82.5675 40.8906 82.9886C40.8906 83.4099 41.2469 83.7506 41.687 83.7506H63.26C63.7003 83.7506 64.0564 83.4097 64.0564 82.9886C64.0564 82.5675 63.7003 82.2266 63.26 82.2266Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.26 85.8848H41.687C41.2467 85.8848 40.8906 86.2257 40.8906 86.6468C40.8906 87.0681 41.2469 87.4088 41.687 87.4088H63.26C63.7003 87.4088 64.0564 87.0679 64.0564 86.6468C64.0564 86.2257 63.7003 85.8848 63.26 85.8848Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7877 91.9805H41.4229C41.1286 91.9805 40.8906 92.3214 40.8906 92.7425C40.8906 93.1638 41.1287 93.5045 41.4229 93.5045H65.7877C66.082 93.5045 66.32 93.1636 66.32 92.7425C66.32 92.3212 66.082 91.9805 65.7877 91.9805Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7877 98.0762H41.4229C41.1286 98.0762 40.8906 98.4171 40.8906 98.8382C40.8906 99.2595 41.1287 99.6002 41.4229 99.6002H65.7877C66.082 99.6002 66.32 99.2593 66.32 98.8382C66.32 98.4169 66.082 98.0762 65.7877 98.0762Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6997 103.541C57.0791 102.889 57.4585 102.238 57.654 102.271C57.8494 102.304 57.8494 103.041 57.9592 103.095C58.069 103.149 58.2887 102.498 58.4018 102.428C58.515 102.358 58.515 102.889 58.515 103.129C58.515 103.3 58.8744 102.612 59.4689 101.917C59.6181 101.743 59.8038 102.319 59.8752 102.541C59.9466 102.762 59.9866 102.711 60.3765 101.99C60.7665 101.27 61.5053 99.882 61.9658 98.9614C62.4263 98.0408 62.586 97.6295 62.6983 97.3748C62.8105 97.1201 62.8704 97.0345 62.5818 98.4725C62.2932 99.9105 61.6542 102.875 61.1353 104.753C60.6165 106.632 60.2371 107.334 59.9717 107.756C59.7064 108.178 59.5666 108.298 59.3748 108.188C58.8078 107.864 58.5967 107.092 58.4055 106.428C58.299 106.058 58.2342 105.609 58.1931 105.106C58.1519 104.602 58.1519 104.054 58.3017 103.488C58.6103 102.324 59.2393 101.707 59.5615 101.611C59.6994 101.571 59.8038 101.602 59.8852 101.739C60.3274 102.485 59.6665 102.969 59.6837 103.09C59.7096 103.271 60.4597 103.245 59.7796 103.297C59.0995 103.35 57.1427 103.367 55.3459 103.316C53.5491 103.265 51.9716 103.145 51.2588 103.057C50.546 102.97 50.7457 102.918 52.9552 102.849C55.1646 102.78 59.3778 102.694 62.5567 102.496C65.7355 102.297 67.7522 101.989 69.8906 101.671",
    stroke: "#0F574E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.73375,
    y: 14.3216,
    width: 65.356,
    height: 91.47,
    rx: 5.865,
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.46875,
    y: 15.0566,
    width: 63.886,
    height: 43.8342,
    rx: 5.13,
    fill: "#E9FBF9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 58.8906H73.5855",
    stroke: "#0F574E",
    strokeWidth: 1.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1565 44.9025C41.1666 44.9025 41.1763 44.9047 41.1863 44.9047C41.1963 44.9047 41.2041 44.9029 41.2131 44.9028C43.1863 44.8936 45.0755 44.1037 46.4675 42.7058C47.8595 41.308 48.641 39.4159 48.641 37.4436C48.641 35.4712 47.8595 33.5792 46.4675 32.1813C45.0755 30.7834 43.1863 29.9935 41.2131 29.9843C41.2041 29.9843 41.1953 29.9824 41.1863 29.9824C41.1773 29.9824 41.1666 29.9843 41.1565 29.9845C39.1817 29.991 37.2899 30.7797 35.8958 32.1778C34.5016 33.576 33.7188 35.4695 33.7188 37.4435C33.7188 39.4176 34.5016 41.3111 35.8958 42.7092C37.2899 44.1074 39.1817 44.8961 41.1565 44.9025ZM35.3879 39.6783C36.0818 40.0703 36.9702 40.3889 38.0223 40.606C38.2393 41.6568 38.5577 42.5444 38.9494 43.2379C38.141 42.9243 37.4069 42.4458 36.7937 41.833C36.1805 41.2201 35.7017 40.4863 35.3879 39.6783ZM37.814 39.2838C35.9409 38.8178 34.9661 38.0427 34.9661 37.4437C34.9661 36.8447 35.9409 36.07 37.814 35.6032C37.6799 36.8264 37.6799 38.0606 37.814 39.2838ZM41.1868 31.2266H41.1902C41.7892 31.2307 42.562 32.2043 43.0271 34.0727C41.8034 33.9384 40.5687 33.9384 39.345 34.0727C39.8104 32.2045 40.5829 31.2313 41.1819 31.2266C41.1836 31.2268 41.1852 31.2266 41.1868 31.2266ZM39.0987 35.3567C40.4839 35.1685 41.8883 35.1685 43.2735 35.3567C43.4622 36.7413 43.4622 38.1451 43.2735 39.5298C41.8883 39.7179 40.4839 39.7179 39.0987 39.5298C38.9105 38.1451 38.9105 36.7414 39.0987 35.3567ZM39.345 40.814C40.5687 40.9481 41.8034 40.9481 43.0271 40.814C42.5621 42.6826 41.7892 43.6559 41.1902 43.6601H41.1868C41.1852 43.6601 41.1836 43.6601 41.1819 43.6601C40.5829 43.6556 39.8102 42.6824 39.345 40.8145V40.814ZM43.4228 43.2379C43.8146 42.5443 44.133 41.6567 44.3499 40.6057C45.4018 40.3887 46.2902 40.0702 46.984 39.6783C46.6703 40.4863 46.1917 41.2202 45.5785 41.8331C44.9654 42.446 44.2313 42.9246 43.4229 43.2382L43.4228 43.2379ZM44.5583 35.6029C46.4317 36.0693 47.4063 36.8441 47.4063 37.4434C47.4063 38.0427 46.4317 38.8175 44.5583 39.2835C44.6928 38.0603 44.6928 36.8261 44.5583 35.6029ZM46.9841 35.2081C46.2902 34.8163 45.4018 34.4978 44.3499 34.2808C44.133 33.2298 43.8146 32.3421 43.4228 31.6486C44.2312 31.9622 44.9654 32.4407 45.5785 33.0536C46.1917 33.6665 46.6704 34.4004 46.9841 35.2085V35.2081ZM38.949 31.6492C38.5574 32.3427 38.239 33.2302 38.0221 34.2811C36.97 34.4982 36.0818 34.8168 35.3876 35.2089C35.7014 34.4009 36.1802 33.6671 36.7933 33.0542C37.4065 32.4414 38.1407 31.9629 38.949 31.6492Z",
    fill: "#168374"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 101.405V110.811C1 113.645 3.29795 115.943 6.13262 115.943H15.0187",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8516 101.405V110.811C80.8516 113.645 78.5536 115.943 75.7189 115.943H66.8329",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.5953V9.18926C1 6.35459 3.29795 4.05664 6.13262 4.05664H15.0187",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8516 18.5953V9.18926C80.8516 6.35459 78.5536 4.05664 75.7189 4.05664H66.8329",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.1549,
    cy: 15.8284,
    rx: 7.26428,
    ry: 7.52371,
    fill: "#ECFDF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72 8.12695C70.4425 8.12695 68.9199 8.58881 67.6249 9.45413C66.3299 10.3194 65.3205 11.5494 64.7245 12.9883C64.1284 14.4273 63.9725 16.0107 64.2763 17.5383C64.5802 19.0659 65.3302 20.4691 66.4315 21.5704C67.5329 22.6718 68.9361 23.4218 70.4637 23.7256C71.9913 24.0295 73.5747 23.8735 75.0136 23.2775C76.4526 22.6815 77.6825 21.6721 78.5478 20.3771C79.4131 19.082 79.875 17.5595 79.875 16.002C79.875 13.9134 79.0453 11.9103 77.5685 10.4335C76.0916 8.95664 74.0886 8.12695 72 8.12695ZM70.875 19.1468L68.0625 16.3343L68.9572 15.4395L70.875 17.3571L75.0431 13.1895L75.9407 14.0815L70.875 19.1468Z",
    fill: "#00D492"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6970_149799",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 13,
    width: 67,
    height: 94
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111.218,
    y: 14.2513,
    width: 64.7986,
    height: 91.47,
    rx: 5.865,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6970_149799)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6970_149799",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: -4,
    width: 82,
    height: 114
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.624,
    y: -2.38539,
    width: 78.9059,
    height: 111.519,
    rx: 5.865,
    fill: "white",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6970_149799)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.969,
    y: -1.65039,
    width: 84.2186,
    height: 110.049,
    rx: 5.13,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.704,
    y: 60.0944,
    width: 34.7044,
    height: 13.3552,
    rx: 4.395,
    fill: "#7CE9DA",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.743,
    y: 94.3053,
    width: 21.139,
    height: 4.232,
    rx: 2.116,
    fill: "#A8F0E7",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79 87.9196H135.308C136.843 87.9196 138.091 86.6116 138.091 85.0047V69.6884C138.091 68.0814 136.842 66.7734 135.308 66.7734H117.79C116.256 66.7734 115.008 68.0814 115.008 69.6884V85.0047C115.008 86.6116 116.256 87.9196 117.79 87.9196ZM131.593 86.3967H121.506V85.3579C121.506 83.4862 122.447 81.8497 123.851 80.9109C124.645 81.4243 125.567 81.7241 126.552 81.7241C127.536 81.7241 128.456 81.4249 129.248 80.9125C130.652 81.8514 131.593 83.487 131.593 85.3581V86.3967ZM122.66 75.8535C122.66 73.4518 124.406 71.4983 126.552 71.4983C128.695 71.4983 130.439 73.4518 130.439 75.8535C130.439 78.2509 128.695 80.2012 126.552 80.2012C124.407 80.2012 122.66 78.2507 122.66 75.8535ZM116.461 69.6884C116.461 68.9209 117.057 68.2963 117.79 68.2963H135.308C136.041 68.2963 136.638 68.9209 136.638 69.6884V85.0047C136.638 85.7722 136.041 86.3967 135.308 86.3967H133.046V85.3579C133.046 83.1214 132.002 81.1451 130.408 79.9036C131.325 78.849 131.892 77.4239 131.892 75.8534C131.892 72.6121 129.497 69.9753 126.552 69.9753C123.605 69.9753 121.207 72.612 121.207 75.8534C121.207 77.4219 121.773 78.8452 122.689 79.8994C121.093 81.1402 120.053 83.1207 120.053 85.3579V86.3967H117.79C117.057 86.3967 116.461 85.7722 116.461 85.0047V69.6884Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.549 80.5918H147.976C147.536 80.5918 147.18 80.9327 147.18 81.3538C147.18 81.7751 147.536 82.1159 147.976 82.1159H169.549C169.989 82.1159 170.345 81.7749 170.345 81.3538C170.345 80.9327 169.989 80.5918 169.549 80.5918Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.549 84.25H147.976C147.536 84.25 147.18 84.5909 147.18 85.012C147.18 85.4333 147.536 85.7741 147.976 85.7741H169.549C169.989 85.7741 170.345 85.4331 170.345 85.012C170.345 84.5909 169.989 84.25 169.549 84.25Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 90.3457H147.977C147.536 90.3457 147.18 90.6866 147.18 91.1077C147.18 91.529 147.536 91.8698 147.977 91.8698H184.484C184.925 91.8698 185.281 91.5289 185.281 91.1077C185.281 90.6865 184.925 90.3457 184.484 90.3457Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.484 96.4414H147.977C147.536 96.4414 147.18 96.7823 147.18 97.2034C147.18 97.6247 147.536 97.9655 147.977 97.9655H184.484C184.925 97.9655 185.281 97.6246 185.281 97.2034C185.281 96.7822 184.925 96.4414 184.484 96.4414Z",
    fill: "#0F574E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.259 105.371C167.763 104.519 168.266 103.666 168.525 103.709C168.784 103.753 168.784 104.717 168.93 104.788C169.076 104.859 169.367 104.006 169.517 103.915C169.667 103.823 169.667 104.519 169.667 104.832C169.667 105.056 170.144 104.156 170.932 103.246C171.13 103.018 171.376 103.772 171.471 104.062C171.566 104.352 171.619 104.285 172.136 103.342C172.653 102.399 173.633 100.582 174.244 99.3765C174.855 98.1713 175.066 97.633 175.215 97.2996C175.364 96.9662 175.444 96.854 175.061 98.7365C174.678 100.619 173.831 104.5 173.142 106.959C172.454 109.417 171.951 110.337 171.599 110.889C171.247 111.442 171.062 111.599 170.807 111.455C170.055 111.031 169.775 110.02 169.522 109.15C169.381 108.666 169.295 108.079 169.24 107.42C169.185 106.76 169.185 106.043 169.384 105.303C169.793 103.778 170.628 102.97 171.055 102.846C171.238 102.792 171.376 102.833 171.484 103.013C172.071 103.99 171.194 104.623 171.217 104.781C171.251 105.018 172.246 104.984 171.344 105.053C170.442 105.122 167.847 105.144 165.464 105.077C163.081 105.01 160.988 104.853 160.043 104.739C159.098 104.624 159.362 104.557 162.293 104.466C165.223 104.375 170.811 104.263 175.028 104.003C179.244 103.744 181.919 103.34 184.755 102.924",
    stroke: "#0F574E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.624,
    y: -2.38539,
    width: 78.9059,
    height: 111.519,
    rx: 5.865,
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.359,
    y: -1.65039,
    width: 77.4359,
    height: 53.5988,
    rx: 5.13,
    fill: "#E9FBF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.797 51.9492H187.081",
    stroke: "#0F574E",
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.765 34.8375C147.777 34.8375 147.789 34.8402 147.801 34.8402C147.813 34.8402 147.823 34.8379 147.834 34.8378C150.226 34.8266 152.515 33.8608 154.203 32.1515C155.89 30.4422 156.837 28.1287 156.837 25.717C156.837 23.3053 155.89 20.9917 154.203 19.2824C152.515 17.5732 150.226 16.6073 147.834 16.5961C147.823 16.5961 147.812 16.5938 147.801 16.5938C147.79 16.5938 147.777 16.5961 147.765 16.5963C145.372 16.6042 143.079 17.5686 141.389 19.2782C139.699 20.9878 138.75 23.3031 138.75 25.7169C138.75 28.1307 139.699 30.446 141.389 32.1556C143.079 33.8652 145.372 34.8296 147.765 34.8375ZM140.773 28.4496C141.614 28.9289 142.691 29.3184 143.966 29.5839C144.229 30.8688 144.615 31.9541 145.09 32.802C144.11 32.4186 143.22 31.8335 142.477 31.0841C141.734 30.3348 141.154 29.4375 140.773 28.4496ZM143.714 27.9671C141.443 27.3973 140.262 26.4496 140.262 25.7172C140.262 24.9847 141.443 24.0374 143.714 23.4667C143.551 24.9624 143.551 26.4715 143.714 27.9671ZM147.802 18.115H147.806C148.532 18.1201 149.469 19.3106 150.033 21.5952C148.549 21.431 147.053 21.431 145.57 21.5952C146.134 19.3108 147.07 18.1208 147.796 18.1151C147.798 18.1153 147.8 18.115 147.802 18.115ZM145.271 23.1652C146.95 22.9351 148.652 22.9351 150.331 23.1652C150.56 24.8583 150.56 26.5748 150.331 28.2679C148.652 28.498 146.95 28.498 145.271 28.2679C145.043 26.5748 145.043 24.8583 145.271 23.1652ZM145.57 29.8382C147.053 30.0022 148.549 30.0022 150.033 29.8382C149.469 32.123 148.532 33.3132 147.806 33.3183H147.802C147.8 33.3183 147.798 33.3183 147.796 33.3183C147.07 33.3128 146.133 32.1228 145.57 29.8388V29.8382ZM150.512 32.802C150.987 31.954 151.373 30.8686 151.636 29.5835C152.911 29.3181 153.988 28.9287 154.829 28.4495C154.449 29.4375 153.868 30.3349 153.125 31.0843C152.382 31.8338 151.492 32.4189 150.512 32.8024L150.512 32.802ZM151.889 23.4663C154.159 24.0365 155.341 24.9839 155.341 25.7168C155.341 26.4496 154.159 27.3969 151.889 27.9667C152.052 26.4711 152.052 24.9619 151.889 23.4663ZM154.829 22.9836C153.988 22.5045 152.911 22.115 151.636 21.8497C151.373 20.5645 150.987 19.479 150.512 18.6311C151.492 19.0146 152.382 19.5997 153.125 20.3491C153.868 21.0986 154.449 21.9959 154.829 22.984V22.9836ZM145.09 18.6319C144.615 19.4798 144.229 20.565 143.966 21.85C142.691 22.1155 141.614 22.505 140.773 22.9844C141.153 21.9965 141.733 21.0992 142.477 20.3498C143.22 19.6005 144.11 19.0154 145.09 18.6319Z",
    fill: "#168374"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.953 100.717V109.881C102.953 112.716 105.251 115.014 108.086 115.014H117.358",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185 100.717V109.881C185 112.716 182.702 115.014 179.867 115.014H170.595",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.953 19.2833V10.1189C102.953 7.28428 105.251 4.98633 108.086 4.98633H117.358",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M185 19.2833V10.1189C185 7.28428 182.702 4.98633 179.867 4.98633H170.595",
    stroke: "#0F574E",
    strokeWidth: 1.92473,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.485,
    cy: 16.8362,
    rx: 7.52371,
    ry: 7.52371,
    fill: "#ECFDF5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M173.32 9.12695C168.776 9.12695 165.164 12.6145 165.164 17.002C165.164 21.3895 168.776 24.877 173.32 24.877C177.865 24.877 181.477 21.3895 181.477 17.002C181.477 12.6145 177.865 9.12695 173.32 9.12695ZM176.466 20.9395L173.32 17.902L170.174 20.9395L169.242 20.0395L172.388 17.002L169.242 13.9645L170.174 13.0645L173.32 16.102L176.466 13.0645L177.398 13.9645L174.252 17.002L177.398 20.0395L176.466 20.9395Z",
    fill: "#FF6467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOpenPassport);
export default __webpack_public_path__ + "static/media/img-open-passport.e485aabc183bddae85c7d0fba3627c69.svg";
export { ForwardRef as ReactComponent };